import { getFileClient } from "@/features/PromptbookRuntime/files/fileClient";
import { useSecrets } from "@/features/Secrets/hooks/useSecrets";

/**
 * Load the configuration for the promptbook runtime
 *
 * @returns
 */
export const useRuntimeConfig = (promptbookId: string, filesToLoad: string[]) => {
  const { data: secrets, isLoading, error } = useSecrets();

  const fileClient = getFileClient(promptbookId);

  const secretMap = Object.values(secrets || {}).reduce(
    (acc, cur) => {
      return {
        ...acc,
        [cur.resourceId]: cur.value,
      };
    },
    {} as Record<string, string>,
  );

  const isLoadingConfig = isLoading;
  const errorLoadingConfig = error;

  return {
    config: {
      sandbox: { secrets: secretMap },
      storage: { defaultFiles: filesToLoad, fileClient },
    },
    isLoadingConfig,
    errorLoadingConfig,
  };
};
